// import apiClient from 'config/axios.config';

// const appointmentServices = {
//   getBookings: async (params = {}) => {
//     const response = await apiClient.get('/booking', { params });
//     return response.data;
//   },

//   getBookingById: async (id) => {
//     const response = await apiClient.get(`/booking/${id}`);
//     return response.data;
//   },

//   /*
//   updateBooking: async (id, data) => {
//     const response = await apiClient.put(`/admin/bookings/${id}`, data);
//     return response.data;
//   },

//   cancelBooking: async (id, data) => {
//     const response = await apiClient.post(`/booking/${id}/cancel`, data);
//     return response.data;
//   },

//   rejectBooking: async (id, data) => {
//     const response = await apiClient.post(`/booking/${id}/reject`, data);
//     return response.data;
//   },

//   rescheduleBooking: async (id, data) => {
//     const response = await apiClient.post(`/booking/${id}/reschedule`, data);
//     return response.data;
//   },

//   addRating: async (id, data) => {
//     const response = await apiClient.post(`/admin/bookings/${id}/rating`, data);
//     return response.data;
//   },

//   assignStaff: async (id, data) => {
//     const response = await apiClient.post(`/admin/bookings/${id}/assign-staff`, data);
//     return response.data;
//   },
//   */
// };

// export default appointmentServices;


import apiClient from 'config/axios.config';

const appointmentServices = {
  // ✅ GET ALL APPOINTMENTS (ADMIN)
  getAppointments: async (params = {}) => {
    const response = await apiClient.get(
      '/property/admin/listing/appointments',
      { params }
    );
    return response.data;
  },

  // ✅ GET SINGLE APPOINTMENT
  getAppointmentById: async (id) => {
    const response = await apiClient.get(
      `/property/admin/appointments/${id}`
    );
    return response.data;
  },

exportAppointments: async ({
  status,
  type,
  startDate,
  endDate,
  search,
  sortBy,
  sortOrder,
}) => {
  const params = new URLSearchParams({
    status: status || '',
    type: type || '',
    startDate: startDate || '',
    endDate: endDate || '',
    search: search || '',
    sortBy: sortBy || '',
    sortOrder: sortOrder || '',
  });

  for (const [key, value] of [...params.entries()]) {
    if (!value) params.delete(key);
  }

  return apiClient.get(
    `/property/admin/listing/appointments/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};

export default appointmentServices;

